/* Publish by EComposer at 2026-10-01 15:24:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ytgexagzer"]=  window.__ectimmers["ecom-ytgexagzer"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ytgexagzer').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ytgexagzer', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sk1bh1ixfv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sk1bh1ixfv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4bcya3jtu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4bcya3jtu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qcej80riulh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qcej80riulh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t9nb7e19arp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t9nb7e19arp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmio13oyr7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmio13oyr7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zlf1mcxpu6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zlf1mcxpu6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1p2jgazfc3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1p2jgazfc3w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q64x5y9ch4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q64x5y9ch4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v78nxnqgjg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v78nxnqgjg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sriuu55dv0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sriuu55dv0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s16yisfbc8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s16yisfbc8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72qqhbj4yvw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72qqhbj4yvw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h54hcypcck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h54hcypcck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6rw8ydy1be').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6rw8ydy1be', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oeni6ouero').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oeni6ouero', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-boqfu4qj8gc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-boqfu4qj8gc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ezicdokizpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ezicdokizpb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-won7uss2h8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-won7uss2h8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fk1h080jgyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fk1h080jgyf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bq5hrf7i5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bq5hrf7i5v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jptesrhvoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jptesrhvoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwg76q396v9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwg76q396v9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n499rhoag9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n499rhoag9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37mxiakoeul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37mxiakoeul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-badj3l1313t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-badj3l1313t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45z4taeqdt4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45z4taeqdt4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pqvwjxcs18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqvwjxcs18', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmb2paj7mg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmb2paj7mg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmsrpxv5c0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmsrpxv5c0m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ysw472sp0rs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ysw472sp0rs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ernsfvtw9ch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ernsfvtw9ch', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfi5lx8u26').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfi5lx8u26', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9nbg9iydq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9nbg9iydq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-037eor744jct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-037eor744jct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m42y8wqmn7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m42y8wqmn7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtwf11i3akk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtwf11i3akk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j7foowmdvx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j7foowmdvx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrcm8v6klca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrcm8v6klca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4a36et1m8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4a36et1m8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2thhtqyjo8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2thhtqyjo8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-otkyxaqv3kc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-otkyxaqv3kc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv6s4e3ocpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv6s4e3ocpo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7skcn0vcv9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7skcn0vcv9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pssiwun3adf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pssiwun3adf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xrkvv3f7kq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xrkvv3f7kq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mhv1jwti1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mhv1jwti1f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5rauyb37op').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5rauyb37op', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yu0xt2arv9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yu0xt2arv9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr75jl2mmfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr75jl2mmfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uoyal97ixcd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uoyal97ixcd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zptt13no92i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zptt13no92i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qka893ur1v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qka893ur1v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-socd0c48mn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-socd0c48mn9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g81sa7omjqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g81sa7omjqk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16nboqkjocmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16nboqkjocmh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xs2emwllxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xs2emwllxr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0oo729qg0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0oo729qg0m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ny0dnq8ih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ny0dnq8ih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aihr5zgk7ai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aihr5zgk7ai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edddickid38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edddickid38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wksoj5fhlv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wksoj5fhlv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clgeu0eq0nk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clgeu0eq0nk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ufnslxf7t5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ufnslxf7t5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2j167dof5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2j167dof5k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8u59drf2reh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8u59drf2reh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hes6ll7tw0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hes6ll7tw0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-utcwazeyy2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utcwazeyy2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvgxx93qxss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvgxx93qxss', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ujf4009sn4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ujf4009sn4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4qz3rxqbsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4qz3rxqbsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fbogyebh6ko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fbogyebh6ko', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n38pers6mra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n38pers6mra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wpuiseuqgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wpuiseuqgw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6k2lw8xdyuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6k2lw8xdyuw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9la3jka7e9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9la3jka7e9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph5s5zvfe8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph5s5zvfe8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dqf38gsd0u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dqf38gsd0u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0t68906di0gc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0t68906di0gc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9h73wpjpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9h73wpjpb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfqt64nnmul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfqt64nnmul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fktexi882nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fktexi882nq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9okzm5at177').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9okzm5at177', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z783t7km6fj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z783t7km6fj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3ejc1wwa3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3ejc1wwa3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c96clxf0rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c96clxf0rc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bx3ao6xc9jc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bx3ao6xc9jc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-873tf35n2kt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-873tf35n2kt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45m2g5eb3qt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45m2g5eb3qt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqg0q2tcd5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqg0q2tcd5i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-stzl1lyvci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-stzl1lyvci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lys7j4zw75g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lys7j4zw75g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wczbou5417').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wczbou5417', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbowrs21i4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbowrs21i4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xuf9bo93nu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xuf9bo93nu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iga37f3b2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iga37f3b2j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6hjhblp2yer').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hjhblp2yer', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ncpd3l59qas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ncpd3l59qas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4zuolrcwcb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4zuolrcwcb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2cmdcb7ijg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2cmdcb7ijg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ckel1w6k3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ckel1w6k3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93dc2kyad45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93dc2kyad45', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jz7orka99vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jz7orka99vb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll6h43ua38p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll6h43ua38p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pf4t9wj84uc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pf4t9wj84uc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2m3dyf8xlna').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2m3dyf8xlna', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxjanulkgh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxjanulkgh9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snbozk1227m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snbozk1227m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppei292v51').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppei292v51', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75qbll565r4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75qbll565r4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2a8q6ghrtt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2a8q6ghrtt9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fk50f52xvy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fk50f52xvy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zai0sj1lds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zai0sj1lds', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7112zi8fgq2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7112zi8fgq2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgnp2hcyn9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgnp2hcyn9m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6r41r1zj5wh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6r41r1zj5wh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xae2x7n5wo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xae2x7n5wo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k3l41f1xv0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k3l41f1xv0c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-711of28desl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-711of28desl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8keq39smg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8keq39smg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccexb7yhd68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccexb7yhd68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74gvy9glegx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74gvy9glegx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tzk9bidf0ut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tzk9bidf0ut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dcb9b14wiy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dcb9b14wiy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-anh6i0c6eva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-anh6i0c6eva', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3wwt88htj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3wwt88htj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ye6gcrsv1pn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ye6gcrsv1pn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-baeye1s5f0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-baeye1s5f0r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ytiqlg8wy97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ytiqlg8wy97', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmduyylt1mk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmduyylt1mk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yb4ert1djt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yb4ert1djt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kb1ogqe2or').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kb1ogqe2or', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqx503pdgmq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqx503pdgmq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-awt9kexl6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-awt9kexl6g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ur796dvzkgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ur796dvzkgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsaeeuvu7ip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsaeeuvu7ip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdk7pxl01').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdk7pxl01', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rs4oi23os').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rs4oi23os', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cj125fxagsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cj125fxagsd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vtr06cv7fup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vtr06cv7fup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmttijh9e8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmttijh9e8m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h27jx1u0ty8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h27jx1u0ty8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apphmkl8229').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apphmkl8229', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwwd6zu5loj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwwd6zu5loj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g33ne95wyzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g33ne95wyzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pw22speracl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pw22speracl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2t7wj1e87l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2t7wj1e87l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zo6taybkh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zo6taybkh7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j1ebqidz9kc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j1ebqidz9kc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ff04q5n0ipa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ff04q5n0ipa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwl74r4clcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwl74r4clcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r46eajrmo1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r46eajrmo1q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ytdeng0pmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ytdeng0pmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q6hctiduw7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6hctiduw7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3mq93bktp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3mq93bktp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-357p7bq2579').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-357p7bq2579', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rktlkdfpfpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rktlkdfpfpg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-447muurigg3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-447muurigg3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyaxs5jxjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyaxs5jxjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5bxpbribtk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5bxpbribtk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9amvaecccsu"]=  window.__ectimmers["ecom-9amvaecccsu"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-9amvaecccsu"]["6joo5nta3"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-9amvaecccsu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9amvaecccsu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgnb769v7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgnb769v7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3l4f7eycowa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3l4f7eycowa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtcaq2ayg2u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtcaq2ayg2u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4rzgk5f5kg6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4rzgk5f5kg6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3o3v3xjfn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3o3v3xjfn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijdg09fdce8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijdg09fdce8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eiur4dpixm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eiur4dpixm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0zx8iiwjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0zx8iiwjf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ne3uojv4m5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ne3uojv4m5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lho63er2k38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lho63er2k38', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jifkt55m8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jifkt55m8y', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3uug5vcqkf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3uug5vcqkf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t48foze8v5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t48foze8v5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d06onq5b756').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d06onq5b756', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s6lwzbzdte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s6lwzbzdte', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31fpuy7yy69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31fpuy7yy69', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34cfcvejovn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34cfcvejovn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3913arzth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3913arzth', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bcyhzbicgxp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bcyhzbicgxp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4qp4ahnnsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4qp4ahnnsj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q2o4nuzle9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q2o4nuzle9k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5ttzzuaq2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5ttzzuaq2e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ug8d8cbipb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ug8d8cbipb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxc6v98i84l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxc6v98i84l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3iz5gk0k0im').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3iz5gk0k0im', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbtaqd8lnu4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbtaqd8lnu4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6u1rq6mb0wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6u1rq6mb0wa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4xjunnl0lv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4xjunnl0lv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljfism4e90o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljfism4e90o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yhkil471vsp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yhkil471vsp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-re2umoyl0xr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-re2umoyl0xr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9t2oksnyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9t2oksnyr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7dbsk98x8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7dbsk98x8g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3m3pwjlg1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3m3pwjlg1s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tqfwvirv8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqfwvirv8r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gob781dj40n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gob781dj40n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8eybe6xx6cc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8eybe6xx6cc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ili6svl2ct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ili6svl2ct', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryuh10pzrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryuh10pzrl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9fvke1m6km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9fvke1m6km', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yoj35ch6yl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yoj35ch6yl9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1sqio8a4duq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1sqio8a4duq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnmmj0gav9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnmmj0gav9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-29h3yglk06x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29h3yglk06x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2phzt54u11i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2phzt54u11i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e1dfc11lek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e1dfc11lek', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mt424az7srr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mt424az7srr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6w2mwxo6jvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6w2mwxo6jvr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yblvb0zs8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yblvb0zs8m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9i2pckxavx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9i2pckxavx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zhd8tslqvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zhd8tslqvd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tyhypvae32n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tyhypvae32n', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-r5uuf1kvqce"]=  window.__ectimmers["ecom-r5uuf1kvqce"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-r5uuf1kvqce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r5uuf1kvqce', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vw6rdukcvee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vw6rdukcvee', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4c76jv615o9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4c76jv615o9', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9shszosro1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9shszosro1', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3km61say9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3km61say9a', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xzj714y255').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xzj714y255', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cv1lqf6a4x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cv1lqf6a4x', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5k2a9ftola').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5k2a9ftola', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1hdah6gyp99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1hdah6gyp99', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qzc9ae261g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzc9ae261g', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhq5ahs61a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhq5ahs61a', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ya2l1jzkkfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ya2l1jzkkfe', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ntwoq5o240n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ntwoq5o240n', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w12iupb0to').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w12iupb0to', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcccfe64q2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcccfe64q2d', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ji226wc3q6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ji226wc3q6l', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_auto_close__mobile":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0tvevvgqq6j"]=  window.__ectimmers["ecom-0tvevvgqq6j"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-0tvevvgqq6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0tvevvgqq6j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y3zloj494eb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y3zloj494eb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w1jf1vfp7s8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w1jf1vfp7s8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9if6gu0bjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9if6gu0bjs', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzccdr3yr5c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzccdr3yr5c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubjzavehfu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubjzavehfu', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bs9s4dmmz9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bs9s4dmmz9i', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-veeibgf7ap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-veeibgf7ap', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6xzdcyusy6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6xzdcyusy6b', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09aoa2bhgnbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09aoa2bhgnbb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihe5wio3q4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihe5wio3q4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h946ov3pelk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h946ov3pelk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5c5i1abhff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5c5i1abhff', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ltpmvnmap58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ltpmvnmap58', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8afz72rwlgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8afz72rwlgk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwklpeidlls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwklpeidlls', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7mz0ue62a8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7mz0ue62a8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-r7vax2tym7"]=  window.__ectimmers["ecom-r7vax2tym7"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const f=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(f)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-r7vax2tym7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7vax2tym7', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ezhos0efn6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ezhos0efn6i', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}